/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import {
  PREVIEWURL_FETCH_START,
  PREVIEWURL_FETCH_SUCCESS,
  PREVIEWURL_FETCH_FAILURE,
} from './actions';

import Resource from '../../resource/Resource';

export function fetchPreviewUrl(posts) {
  return (dispatch) => {
    const dispatchObjects = {
      start: PREVIEWURL_FETCH_START,
      success: PREVIEWURL_FETCH_SUCCESS,
      error: PREVIEWURL_FETCH_FAILURE,
    };
    dispatch({ type: dispatchObjects.start });
    const postsById = {};
    posts.forEach((post) => {
      postsById[post.id] = post;
    });
    const postIds = [];
    const storageKeys = [];

    for (const post of Immutable.fromJS(postsById).values()) {
      const type = post.getIn(['display', 'type']);
      if (type === 'files') {
        const displayData = post.getIn(['display', 'data']);
        const storageKey = displayData.getIn(['files', 0, 'storageKey'], '');
        if (storageKey !== '') {
          storageKeys.push(storageKey);
          postIds.push(post.get('id'));
        }
      }
    }
    if (storageKeys.length > 0) {
      return Resource.lookup('upload', 'getPreviewURLs', { storageKeys }).then(
        (data) => {
          dispatch({
            type: dispatchObjects.success,
            postIds,
            previewurldata: data,
          });
        }
      );
    }
    return Promise.resolve();
  };
}
